import { useIntl } from "react-intl";
import { CostItemStatus } from "gql/index";

export const useCostItemStatusOptions = () => {
  const { formatMessage } = useIntl();

  return [
    {
      value: CostItemStatus.Planned,
      label: formatMessage({ id: 'Planned' }),
    },
    {
      value: CostItemStatus.InProgress,
      label: formatMessage({ id: 'In progress' }),
    },
 
    {
      value: CostItemStatus.Completed,
      label: formatMessage({ id: 'Completed' }),
    }
  ];
};

